/* tslint:disable */
/* eslint-disable */
/**
 * Bank Backoffice Gateway - FIP onboarding External
 * Partner\'s Bank Backoffice Gateway - FIP onboarding. External.
 *
 * The version of the OpenAPI document: 2.0
 * Contact: jiri.bilek@partnersbanka.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// URLSearchParams not necessarily used
// @ts-ignore

// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction,
    type EndpointOptions, // THIS IS CUSTOM
  } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @enum {string}
 */

export const AccountProductCodeV2 = {
    CURRENT_ACCOUNT_BASIC: 'OP_CURRENT_ACCOUNT_BASIC',
    CURRENT_ACCOUNT_SECONDARY: 'OP_CURRENT_ACCOUNT_SECONDARY',
    SAVINGS_ACCOUNT_BASIC: 'OP_SAVINGS_ACCOUNT_BASIC',
    SAVINGS_ACCOUNT_GOAL: 'OP_SAVINGS_ACCOUNT_GOAL',
    SAVINGS_ACCOUNT_CASH_RESERVE: 'OP_SAVINGS_ACCOUNT_CASH_RESERVE',
    CURRENT_ACCOUNT_SHARED: 'OP_CURRENT_ACCOUNT_SHARED',
    SAVINGS_ACCOUNT_SHARED: 'OP_SAVINGS_ACCOUNT_SHARED',
    SAVINGS_GOAL_SHARED: 'OP_SAVINGS_GOAL_SHARED',
    CURRENT_ACCOUNT_CHILD: 'OP_CURRENT_ACCOUNT_CHILD',
    SAVINGS_ACCOUNT_CHILD: 'OP_SAVINGS_ACCOUNT_CHILD',
    SAVINGS_ACCOUNT_GOAL_CHILD: 'OP_SAVINGS_ACCOUNT_GOAL_CHILD'
} as const;

export type AccountProductCodeV2 = typeof AccountProductCodeV2[keyof typeof AccountProductCodeV2];


/**
 * The adviser to whom the application is linked
 * @export
 * @interface AdvisorV2
 */
export interface AdvisorV2 {
    /**
     * ID from the external system.
     * @type {number}
     * @memberof AdvisorV2
     */
    'fipId': number;
    /**
     * Pid UUID
     * @type {string}
     * @memberof AdvisorV2
     */
    'pidUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdvisorV2
     */
    'functionId'?: string;
}
/**
 * 
 * @export
 * @interface ApplicationAdvisorV2
 */
export interface ApplicationAdvisorV2 {
    /**
     * FIP ID of the advisor.
     * @type {number}
     * @memberof ApplicationAdvisorV2
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationAdvisorV2
     */
    'name'?: string;
}
/**
 * Application list item.
 * @export
 * @interface ApplicationListItemV2
 */
export interface ApplicationListItemV2 {
    /**
     * Unique identifier of the application
     * @type {string}
     * @memberof ApplicationListItemV2
     */
    'applicationUuid': string;
    /**
     * 
     * @type {ProductTypeV2x3}
     * @memberof ApplicationListItemV2
     */
    'product': ProductTypeV2x3;
    /**
     * 
     * @type {OnboardingApplicationStatusV2V2x3}
     * @memberof ApplicationListItemV2
     */
    'status': OnboardingApplicationStatusV2V2x3;
    /**
     * 
     * @type {ApplicationMainClientV2}
     * @memberof ApplicationListItemV2
     */
    'mainClient': ApplicationMainClientV2;
    /**
     * 
     * @type {string}
     * @memberof ApplicationListItemV2
     */
    'expiration': string;
    /**
     * 
     * @type {ApplicationAdvisorV2}
     * @memberof ApplicationListItemV2
     */
    'advisor': ApplicationAdvisorV2;
    /**
     * 
     * @type {string}
     * @memberof ApplicationListItemV2
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationListItemV2
     */
    'updatedAt': string;
}


/**
 * Application main client.
 * @export
 * @interface ApplicationMainClientV2
 */
export interface ApplicationMainClientV2 {
    /**
     * PID UUID of the client.
     * @type {string}
     * @memberof ApplicationMainClientV2
     */
    'pid': string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationMainClientV2
     */
    'name': string;
}
/**
 * Request with application list filter by pidUuid, which uses OR logic for filter\'đ fields.
 * @export
 * @interface ApplicationsListByPidUuidRequestV2
 */
export interface ApplicationsListByPidUuidRequestV2 {
    /**
     * 
     * @type {SortV2x3}
     * @memberof ApplicationsListByPidUuidRequestV2
     */
    'sort'?: SortV2x3;
    /**
     * 
     * @type {PageableV0x2}
     * @memberof ApplicationsListByPidUuidRequestV2
     */
    'pageable': PageableV0x2;
}
/**
 * Response containing list of searched applications.
 * @export
 * @interface ApplicationsListResponseV2
 */
export interface ApplicationsListResponseV2 {
    /**
     * 
     * @type {Array<ApplicationListItemV2>}
     * @memberof ApplicationsListResponseV2
     */
    'applications': Array<ApplicationListItemV2>;
    /**
     * 
     * @type {PageableResponseV0x2}
     * @memberof ApplicationsListResponseV2
     */
    'pageable': PageableResponseV0x2;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ApplicationsSortFieldNameV2x3 = {
    APPLICATION_UUID: 'APPLICATION_UUID',
    PRODUCT: 'PRODUCT',
    STATUS: 'STATUS',
    MAIN_CLIENT_PID: 'MAIN_CLIENT_PID',
    MAIN_CLIENT_NAME: 'MAIN_CLIENT_NAME',
    CREATED_AT: 'CREATED_AT',
    UPDATED_AT: 'UPDATED_AT'
} as const;

export type ApplicationsSortFieldNameV2x3 = typeof ApplicationsSortFieldNameV2x3[keyof typeof ApplicationsSortFieldNameV2x3];


/**
 * 
 * @export
 * @interface BackOfficeOnboardingApplicationAccountV2
 */
export interface BackOfficeOnboardingApplicationAccountV2 {
    /**
     * 
     * @type {string}
     * @memberof BackOfficeOnboardingApplicationAccountV2
     */
    'bankAccountIban': string;
}
/**
 * 
 * @export
 * @interface BackOfficeOnboardingApplicationBundleV2
 */
export interface BackOfficeOnboardingApplicationBundleV2 {
    /**
     * 
     * @type {BundleProductCodeV2x3}
     * @memberof BackOfficeOnboardingApplicationBundleV2
     */
    'bundleProductCode'?: BundleProductCodeV2x3;
    /**
     * 
     * @type {string}
     * @memberof BackOfficeOnboardingApplicationBundleV2
     */
    'advisorCommissionReduction'?: string;
}


/**
 * Contains information about cards on the application.
 * @export
 * @interface BackOfficeOnboardingApplicationCardV2
 */
export interface BackOfficeOnboardingApplicationCardV2 {
    /**
     * 
     * @type {CardTypeV1x3}
     * @memberof BackOfficeOnboardingApplicationCardV2
     */
    'cardType': CardTypeV1x3;
    /**
     * 
     * @type {CardDesignV1x3}
     * @memberof BackOfficeOnboardingApplicationCardV2
     */
    'cardDesign': CardDesignV1x3;
}


/**
 * 
 * @export
 * @interface BackOfficeOnboardingApplicationMainAccountV2
 */
export interface BackOfficeOnboardingApplicationMainAccountV2 {
    /**
     * 
     * @type {AccountProductCodeV2}
     * @memberof BackOfficeOnboardingApplicationMainAccountV2
     */
    'accountProductCode'?: AccountProductCodeV2;
    /**
     * Array of reserved IBANs for the new account.
     * @type {Array<BackOfficeOnboardingApplicationAccountV2>}
     * @memberof BackOfficeOnboardingApplicationMainAccountV2
     */
    'reservedAccounts'?: Array<BackOfficeOnboardingApplicationAccountV2>;
    /**
     * 
     * @type {BackOfficeOnboardingApplicationAccountV2}
     * @memberof BackOfficeOnboardingApplicationMainAccountV2
     */
    'selectedAccount'?: BackOfficeOnboardingApplicationAccountV2;
    /**
     * 
     * @type {Array<BackOfficeOnboardingApplicationCardV2>}
     * @memberof BackOfficeOnboardingApplicationMainAccountV2
     */
    'cards'?: Array<BackOfficeOnboardingApplicationCardV2>;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const BundleProductCodeV2x3 = {
    INDIVIDUAL: 'OB_BUNDLE_INDIVIDUAL',
    COUPLE: 'OB_BUNDLE_COUPLE',
    FAMILY: 'OB_BUNDLE_FAMILY'
} as const;

export type BundleProductCodeV2x3 = typeof BundleProductCodeV2x3[keyof typeof BundleProductCodeV2x3];


/**
 * Card design.
 * @export
 * @enum {string}
 */

export const CardDesignV1x3 = {
    VIRTUAL: 'VIRTUAL',
    FOUNDER: 'FOUNDER',
    DISPOSABLE: 'DISPOSABLE',
    STANDARD_DARK_BLUE: 'STANDARD_DARK_BLUE',
    STANDARD_TURQUOISE: 'STANDARD_TURQUOISE',
    STANDARD_WHITE: 'STANDARD_WHITE',
    STANDARD_CORAL: 'STANDARD_CORAL',
    KIDS_THUMB_UP: 'KIDS_THUMB_UP',
    KIDS_GIRL: 'KIDS_GIRL',
    KIDS_FLIGHT: 'KIDS_FLIGHT',
    KIDS_SKATE: 'KIDS_SKATE',
    COMMON_LO: 'COMMON_LO',
    COMMON_VE: 'COMMON_VE'
} as const;

export type CardDesignV1x3 = typeof CardDesignV1x3[keyof typeof CardDesignV1x3];


/**
 * Card types. * VIRTUAL - Virtual card has no plastic, it exists just in application. * STANDARD - Standard plastic card. * PREMIUM - Plastic card for premium customers. * KIDS - Plastic card for kids, with various kid designs and limited rights. * COMMON - Plastic card for shared accounts. * DISPOSABLE - Virtual card which is after every card payment terminated. 
 * @export
 * @enum {string}
 */

export const CardTypeV1x3 = {
    VIRTUAL: 'VIRTUAL',
    PREMIUM: 'PREMIUM',
    STANDARD: 'STANDARD',
    KIDS: 'KIDS',
    COMMON: 'COMMON',
    DISPOSABLE: 'DISPOSABLE'
} as const;

export type CardTypeV1x3 = typeof CardTypeV1x3[keyof typeof CardTypeV1x3];


/**
 * Reason of application processing failure
 * @export
 * @interface FailedReasonV2
 */
export interface FailedReasonV2 {
    /**
     * 
     * @type {string}
     * @memberof FailedReasonV2
     */
    'failedAt': string;
    /**
     * The reason of the failure (name of exception, type of AML check result)
     * @type {string}
     * @memberof FailedReasonV2
     */
    'reason': string;
    /**
     * Description of the reason (more detailed information)
     * @type {string}
     * @memberof FailedReasonV2
     */
    'description': string;
}
/**
 * The Garant to whom the application is linked
 * @export
 * @interface GarantV2
 */
export interface GarantV2 {
    /**
     * ID from the external system.
     * @type {number}
     * @memberof GarantV2
     */
    'fipId': number;
    /**
     * Pid UUID
     * @type {string}
     * @memberof GarantV2
     */
    'pidUuid'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GarantV2
     */
    'pfsAdvisorFlag'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GarantV2
     */
    'functionId'?: string;
}
/**
 * 
 * @export
 * @interface GetBackOfficeOnboardingApplicationResponseV2
 */
export interface GetBackOfficeOnboardingApplicationResponseV2 {
    /**
     * 
     * @type {UserV2}
     * @memberof GetBackOfficeOnboardingApplicationResponseV2
     */
    'user': UserV2;
    /**
     * 
     * @type {AdvisorV2}
     * @memberof GetBackOfficeOnboardingApplicationResponseV2
     */
    'advisor': AdvisorV2;
    /**
     * 
     * @type {GarantV2}
     * @memberof GetBackOfficeOnboardingApplicationResponseV2
     */
    'garant': GarantV2;
    /**
     * UUID of the application
     * @type {string}
     * @memberof GetBackOfficeOnboardingApplicationResponseV2
     */
    'applicationUuid': string;
    /**
     * FIP process ID
     * @type {number}
     * @memberof GetBackOfficeOnboardingApplicationResponseV2
     */
    'processId': number;
    /**
     * 
     * @type {OnboardingApplicationStatusV2V2x3}
     * @memberof GetBackOfficeOnboardingApplicationResponseV2
     */
    'onboardingApplicationStatus': OnboardingApplicationStatusV2V2x3;
    /**
     * UUID of client
     * @type {string}
     * @memberof GetBackOfficeOnboardingApplicationResponseV2
     */
    'clientPidUuid': string;
    /**
     * 
     * @type {string}
     * @memberof GetBackOfficeOnboardingApplicationResponseV2
     */
    'applicationExpirationDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetBackOfficeOnboardingApplicationResponseV2
     */
    'signatureExpirationDate'?: string;
    /**
     * 
     * @type {BackOfficeOnboardingApplicationBundleV2}
     * @memberof GetBackOfficeOnboardingApplicationResponseV2
     */
    'bundle': BackOfficeOnboardingApplicationBundleV2;
    /**
     * 
     * @type {BackOfficeOnboardingApplicationMainAccountV2}
     * @memberof GetBackOfficeOnboardingApplicationResponseV2
     */
    'mainAccount': BackOfficeOnboardingApplicationMainAccountV2;
    /**
     * 
     * @type {OnboardingApplicationSignatureMethodV2x3}
     * @memberof GetBackOfficeOnboardingApplicationResponseV2
     */
    'selectedSignatureMethod'?: OnboardingApplicationSignatureMethodV2x3;
    /**
     * ID of sign operation related to this onboarding application
     * @type {string}
     * @memberof GetBackOfficeOnboardingApplicationResponseV2
     */
    'signOperationUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetBackOfficeOnboardingApplicationResponseV2
     */
    'marketingAction'?: string;
    /**
     * 
     * @type {Array<FailedReasonV2>}
     * @memberof GetBackOfficeOnboardingApplicationResponseV2
     */
    'failedReasons'?: Array<FailedReasonV2>;
    /**
     * 
     * @type {string}
     * @memberof GetBackOfficeOnboardingApplicationResponseV2
     */
    'mobilityUuid'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const OnboardingApplicationSignatureMethodV2x3 = {
    MOBILE_APPLICATION: 'MOBILE_APPLICATION',
    ANAKIN: 'ANAKIN'
} as const;

export type OnboardingApplicationSignatureMethodV2x3 = typeof OnboardingApplicationSignatureMethodV2x3[keyof typeof OnboardingApplicationSignatureMethodV2x3];


/**
 * Status of the onboarding application. Difference with previous version. One not used status removed and one new status added. It should be save to switch to OnboardingApplicationStatusV2 from OnboardingApplicationStatus. -> SIGNATURE_IN_PREPARATION was removed (we generally didn\'t return application with this status and we stopped to use it several months ago) -> ACCOUNT_CREATED was added (but we generally do not return applications with this status)
 * @export
 * @enum {string}
 */

export const OnboardingApplicationStatusV2V2x3 = {
    ACCOUNT_CREATED: 'ACCOUNT_CREATED',
    BANK_PROCESSING: 'BANK_PROCESSING',
    BANK_PROCESSING_PAUSED: 'BANK_PROCESSING_PAUSED',
    COMPLETED: 'COMPLETED',
    CANCELLED_BY_ADVISOR: 'CANCELLED_BY_ADVISOR',
    CANCELLED_BY_CLIENT: 'CANCELLED_BY_CLIENT',
    CANCELLED_BY_BANK: 'CANCELLED_BY_BANK',
    EXPIRED: 'EXPIRED',
    EXPIRED_NOT_SIGNED: 'EXPIRED_NOT_SIGNED',
    IN_PROGRESS: 'IN_PROGRESS',
    PRODUCT_ACTIVATION_FAILED: 'PRODUCT_ACTIVATION_FAILED',
    SIGNATURE_WAITING_FOR_CLIENT: 'SIGNATURE_WAITING_FOR_CLIENT',
    SIGNED: 'SIGNED'
} as const;

export type OnboardingApplicationStatusV2V2x3 = typeof OnboardingApplicationStatusV2V2x3[keyof typeof OnboardingApplicationStatusV2V2x3];


/**
 * Pagaeble object used for searching. Returns the state of pagination.
 * @export
 * @interface PageableResponseV0x2
 */
export interface PageableResponseV0x2 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof PageableResponseV0x2
     */
    'pageNumber': number;
    /**
     * Number of records per page.
     * @type {number}
     * @memberof PageableResponseV0x2
     */
    'pageSize': number;
    /**
     * Total number of pages with this page size.
     * @type {number}
     * @memberof PageableResponseV0x2
     */
    'totalPages': number;
    /**
     * Total size of all records.
     * @type {number}
     * @memberof PageableResponseV0x2
     */
    'totalSize': number;
}
/**
 * Object for search paging.
 * @export
 * @interface PageableV0x2
 */
export interface PageableV0x2 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof PageableV0x2
     */
    'pageNumber': number;
    /**
     * Maximum number of records per page.
     * @type {number}
     * @memberof PageableV0x2
     */
    'pageSize': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ProductTypeV2x3 = {
    PERSONAL_CURRENT_ACCOUNT: 'PERSONAL_CURRENT_ACCOUNT',
    PERSONAL_SAVING_ACCOUNT: 'PERSONAL_SAVING_ACCOUNT',
    SHARED_CURRENT_ACCOUNT: 'SHARED_CURRENT_ACCOUNT',
    SHARED_SAVING_ACCOUNT: 'SHARED_SAVING_ACCOUNT',
    CHILD_CURRENT_ACCOUNT: 'CHILD_CURRENT_ACCOUNT',
    BUNDLE_SINGLE: 'BUNDLE_SINGLE',
    BUNDLE_COUPLE: 'BUNDLE_COUPLE',
    BUNDLE_FAMILY: 'BUNDLE_FAMILY'
} as const;

export type ProductTypeV2x3 = typeof ProductTypeV2x3[keyof typeof ProductTypeV2x3];


/**
 * Sorting order - ascendent or descendent.
 * @export
 * @enum {string}
 */

export const SortOrderTypeV2x3 = {
    ASC: 'ASC',
    DESC: 'DESC'
} as const;

export type SortOrderTypeV2x3 = typeof SortOrderTypeV2x3[keyof typeof SortOrderTypeV2x3];


/**
 * Sort via given name and order type.
 * @export
 * @interface SortV2x3
 */
export interface SortV2x3 {
    /**
     * 
     * @type {ApplicationsSortFieldNameV2x3}
     * @memberof SortV2x3
     */
    'name': ApplicationsSortFieldNameV2x3;
    /**
     * 
     * @type {SortOrderTypeV2x3}
     * @memberof SortV2x3
     */
    'order': SortOrderTypeV2x3;
}


/**
 * Logged user that created the application
 * @export
 * @interface UserV2
 */
export interface UserV2 {
    /**
     * ID from the external system.
     * @type {number}
     * @memberof UserV2
     */
    'fipId': number;
    /**
     * Pid UUID
     * @type {string}
     * @memberof UserV2
     */
    'pidUuid'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserV2
     */
    'headquartersFlag'?: boolean;
}


/**
 * OnboardingApi - axios parameter creator
 * @export
 */
export const OnboardingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns information about the onboarding application with the given UUID.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} applicationUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationV2: async (xCorrelationId: string, applicationUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getApplicationV2', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'applicationUuid' is not null or undefined
            assertParamExists('getApplicationV2', 'applicationUuid', applicationUuid)
            const localVarPath = `/bank-backofficegateway-fiponboarding-external/v2/onboarding/applications/{applicationUuid}`
                .replace(`{${"applicationUuid"}}`, encodeURIComponent(String(applicationUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {ApplicationsListByPidUuidRequestV2} applicationsListByPidUuidRequestV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingApplicationsByPidUuidV2: async (xCorrelationId: string, pidUuid: string, applicationsListByPidUuidRequestV2: ApplicationsListByPidUuidRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getOnboardingApplicationsByPidUuidV2', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'pidUuid' is not null or undefined
            assertParamExists('getOnboardingApplicationsByPidUuidV2', 'pidUuid', pidUuid)
            // verify required parameter 'applicationsListByPidUuidRequestV2' is not null or undefined
            assertParamExists('getOnboardingApplicationsByPidUuidV2', 'applicationsListByPidUuidRequestV2', applicationsListByPidUuidRequestV2)
            const localVarPath = `/bank-backofficegateway-fiponboarding-external/v2/onboarding/applications/pid/{pidUuid}/list`
                .replace(`{${"pidUuid"}}`, encodeURIComponent(String(pidUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applicationsListByPidUuidRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OnboardingApi - functional programming interface
 * @export
 */
export const OnboardingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OnboardingApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns information about the onboarding application with the given UUID.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} applicationUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApplicationV2(xCorrelationId: string, applicationUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBackOfficeOnboardingApplicationResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApplicationV2(xCorrelationId, applicationUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {ApplicationsListByPidUuidRequestV2} applicationsListByPidUuidRequestV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOnboardingApplicationsByPidUuidV2(xCorrelationId: string, pidUuid: string, applicationsListByPidUuidRequestV2: ApplicationsListByPidUuidRequestV2, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationsListResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOnboardingApplicationsByPidUuidV2(xCorrelationId, pidUuid, applicationsListByPidUuidRequestV2, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OnboardingApi - factory interface
 * @export
 */
export const OnboardingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OnboardingApiFp(configuration)
    return {
        /**
         * Returns information about the onboarding application with the given UUID.
         * @param {OnboardingApiGetApplicationV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApplicationV2(requestParameters: OnboardingApiGetApplicationV2Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<GetBackOfficeOnboardingApplicationResponseV2> {
            return localVarFp.getApplicationV2(requestParameters.xCorrelationId, requestParameters.applicationUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OnboardingApiGetOnboardingApplicationsByPidUuidV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingApplicationsByPidUuidV2(requestParameters: OnboardingApiGetOnboardingApplicationsByPidUuidV2Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<ApplicationsListResponseV2> {
            return localVarFp.getOnboardingApplicationsByPidUuidV2(requestParameters.xCorrelationId, requestParameters.pidUuid, requestParameters.applicationsListByPidUuidRequestV2, options, endpointOptions).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getApplicationV2 operation in OnboardingApi.
 * @export
 * @type OnboardingApiGetApplicationV2Request
 */
export type OnboardingApiGetApplicationV2Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof OnboardingApiGetApplicationV2
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof OnboardingApiGetApplicationV2
     */
    readonly applicationUuid: string
}

/**
 * Request parameters for getOnboardingApplicationsByPidUuidV2 operation in OnboardingApi.
 * @export
 * @type OnboardingApiGetOnboardingApplicationsByPidUuidV2Request
 */
export type OnboardingApiGetOnboardingApplicationsByPidUuidV2Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof OnboardingApiGetOnboardingApplicationsByPidUuidV2
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof OnboardingApiGetOnboardingApplicationsByPidUuidV2
     */
    readonly pidUuid: string

    /**
     * 
     * @type {ApplicationsListByPidUuidRequestV2}
     * @memberof OnboardingApiGetOnboardingApplicationsByPidUuidV2
     */
    readonly applicationsListByPidUuidRequestV2: ApplicationsListByPidUuidRequestV2
}

/**
 * OnboardingApi - object-oriented interface
 * @export
 * @class OnboardingApi
 * @extends {BaseAPI}
 */
export class OnboardingApi extends BaseAPI {
    /**
     * Returns information about the onboarding application with the given UUID.
     * @param {OnboardingApiGetApplicationV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public getApplicationV2(requestParameters: OnboardingApiGetApplicationV2Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return OnboardingApiFp(this.configuration).getApplicationV2(requestParameters.xCorrelationId, requestParameters.applicationUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OnboardingApiGetOnboardingApplicationsByPidUuidV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public getOnboardingApplicationsByPidUuidV2(requestParameters: OnboardingApiGetOnboardingApplicationsByPidUuidV2Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return OnboardingApiFp(this.configuration).getOnboardingApplicationsByPidUuidV2(requestParameters.xCorrelationId, requestParameters.pidUuid, requestParameters.applicationsListByPidUuidRequestV2, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }
}


